import Customer from '../pages/customer/pages/Customer'
import CreateCustomer from '../pages/customer/pages/CreateCustomer';
import CustomerDetails from '../pages/customer/pages/CustomerDetails';
import { USER_ROLES } from '../utils/userRole';
import Communications from '../pages/communications/Communications';

const permissions = [USER_ROLES.ADMIN]


const CustomerRoutes = [
  {
    path: '/customer',
    component: Customer,
    exact: true,
    permissions,
  },
  {
    path: '/customer/create',
    component: CreateCustomer,
    exact: true,
    permissions,
  },
  {
    path: '/customer/edit/:id',
    component: CreateCustomer,
    exact: true,
    permissions,
  },
  {
    path: '/customer/details',
    component: CustomerDetails,
    exact: true,
    permissions,
  },
  // {
  //   path: '/communications',
  //   component: Communications,
  //   exact: true,
  //   permissions: [USER_ROLES.USER],
  // }
];

export default CustomerRoutes
